import React, { useState, useEffect } from 'react';
import { DrmPage, CustomTab } from 'v2/models';
import styles from 'v2/common/DRM/CustomTab/index.module.scss';
import Field from './Field/Field';

type Entity = Record<string, unknown>;
type onUpdate = (updatedEntity: Entity) => void;

interface CustomTabProps<TEntity> {
  tab: CustomTab | undefined;
  entity: TEntity;
  onUpdate: (entity: TEntity) => void;
  drmPage: DrmPage;
}

function CustomTabComponent<TEntity>({
  tab,
  entity,
  onUpdate,
  drmPage,
}: CustomTabProps<TEntity>) {
  const [localEntity, setLocalEntity] = useState<TEntity>(entity);

  const onLocalUpdate = (entity: TEntity) => {
    setLocalEntity(entity);
    onUpdate(entity);
  };

  useEffect(() => {
    setLocalEntity(entity);
  }, [entity]);

  return (
    <div className={styles.fieldsContainer}>
      {tab &&
        tab.field_placements.map((field) => {
          return (
            <div className={styles.field} key={field.field_name}>
              <Field
                drmPage={drmPage}
                field={field}
                entity={localEntity as Entity}
                onUpdate={onLocalUpdate as onUpdate}
              />
            </div>
          );
        })}
    </div>
  );
}

export default CustomTabComponent;
